import { API_LINKS } from "../../constants/api";
import { UserInfo } from "../../interfaces/authentication";
import { firmaLoginTekst } from "../../lib/firmaLogin";

/**
 * Forsidens besked til et medlem, der er logget ind med MitID Erhverv (ADV-356).
 *
 * En firma-session får hverken efteruddannelse eller ID-kort tilbudt, fordi begge er personlige,
 * og uden en forklaring forsvinder de bare fra forsiden. Det er den forvirring, ADV-356 kom af: en
 * advokat, der var logget ind som sin egen virksomhed, ledte efter en funktion, sessionen ikke kan
 * give.
 *
 * Kun for firma-sessioner. En revisor logger ind via et link for at afgive en erklæring og har ingen
 * personlige funktioner her at blive henvist til.
 */
const FirmaLoginBesked = ({
  identityType,
  navn,
}: {
  identityType?: UserInfo["identityType"];
  navn?: string | null;
}) =>
  identityType === "Company" ? (
    <div className="alert alert-info" role="status">
      {firmaLoginTekst(navn)} Efteruddannelse, forsikring og garanti samt
      bestilling af ID-kort er personlige.{" "}
      <a className="alert-link" href={API_LINKS.logout}>
        Log ud
      </a>
      , og log ind med dit private MitID for at bruge dem.
    </div>
  ) : null;

export default FirmaLoginBesked;
